import { OverlayTrigger, Tooltip } from "react-bootstrap";
import React from "react";

const replaceStringLength = 3;

export const getDisplayedLabel = (
  name: string,
  displayedCharactersNum: number,
  evidenceColumnCount?: number,
  isCustomAssessment?: boolean,
  isEvidenceTypeDataOnly?: boolean
): React.ReactNode => {
  const label = name.replace('Assessment - ', '');
  const showTooltip =
    isEvidenceTypeDataOnly &&
    evidenceColumnCount &&
    evidenceColumnCount <= 3 &&
    label.length > displayedCharactersNum + replaceStringLength;

  if (showTooltip) {
    return (
      <OverlayTrigger
        overlay={
          <Tooltip id="fullName" className="customInfoTooltip">
            {name}
            <br />
            Click to show/hide columns
          </Tooltip>
        }
      >
        <span>{`${label.substring(0, displayedCharactersNum)}...`}</span>
      </OverlayTrigger>
    );
  }

  if (isEvidenceTypeDataOnly && !isCustomAssessment) {
    return (
      <OverlayTrigger
        overlay={
          <Tooltip id="fullName" className="customInfoTooltip">
            Click to show/hide columns
          </Tooltip>
        }
      >
        <span>{label}</span>
      </OverlayTrigger>
    );
  }

  return <>{label}</>;
};
